import { money } from 'js/utils/Validation/validationRules';

export const parsePlayerSingleBetLimit = ({ data }) => {
    const { configuration = {}, limits = [] } = data;

    return {
        configuration,
        limit: limits.find(limit => !limit.pending) || {},
        pendingLimits: limits.filter(limit => limit.pending) || []
    };
};

export const getInitialValues = ({ limit: limitData, pendingLimits }) => {
    if (!limitData) {
        return {};
    }

    const limit = limitData.limit?.amount;

    return {
        ...limit ? { limit } : {},
        pendingLimits
    };
};

export const getValidationConfig = () => ({
    limit: [money()]
});
